import classNames from 'classnames'

import {useSelector} from '../../store.js'
import {mainTabsSelector} from './headerSelectors.js'
import Quantity from '../../common/components/Quantity.js'

function Tab({tab}) {
  if (tab.hide) {
    return null
  }

  return (
    <a
      className={classNames('main-nav__link', {active: tab.selected})}
      title={tab.display}
      href={tab.url}
      key={tab.display}
    >
      <span>{tab.display}</span>
      {!!tab.attention && (
        <span className="main-nav__count margin-left-4">
          <Quantity value={tab.attention} />
        </span>
      )}
    </a>
  )
}

export default function NavTabs() {
  const mainTabs = useSelector(mainTabsSelector)

  return (
    <div className="wrap--main-nav-links">
      {mainTabs.map((tab, index) => (
        <Tab key={index} tab={tab} />
      ))}
    </div>
  )
}
